export default __webpack_public_path__ + "static/media/Parent_Parties_Horizontal.5f049dac.png";